var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/numericUpDownButton.scss';
import { SvgIcon } from '../../../SvgIcon/SvgIcon';
import { SvgIconType } from '../../../SvgIcon/SvgIconType';
export const NumericUpDownButton = (_a) => {
    var { isUp, onPointerDown, onPointerUp, onPointerLeave, onPointerCancel } = _a, restProps = __rest(_a, ["isUp", "onPointerDown", "onPointerUp", "onPointerLeave", "onPointerCancel"]);
    const handlePointerDown = (e) => {
        // Keep focus on numeric input; arrow buttons should not capture focus on click/touch.
        e.preventDefault();
        onPointerDown === null || onPointerDown === void 0 ? void 0 : onPointerDown(e);
    };
    return (_jsx("button", Object.assign({ className: `numeric-up-down-button ${isUp ? 'up' : 'down'}`, onPointerDown: handlePointerDown, onPointerUp: onPointerUp, onPointerLeave: onPointerLeave, onPointerCancel: onPointerCancel, tabIndex: -1 }, restProps, { children: _jsx(SvgIcon, { icon: isUp ? SvgIconType.ArrowUp : SvgIconType.ArrowDown }) })));
};
